import React, { useContext } from 'react';
import InputValidatorField from './InputValidatorField';
import {IsValidPassword} from "../../../../utils/Validators";
import { ThemeContext } from 'styled-components';

const InputPassword = ({
    error,
    ...props
}) => {
    const theme = useContext(ThemeContext);
    return (
        <InputValidatorField
            label="Password"
            type="password"
            name="password"
            isValidInput={IsValidPassword}
            InputLabelProps={{
                style: { color: theme.colors.text },
            }}
            InputProps={{
                style: { color: theme.colors.text },
            }}
            error={error}
            {...props}
        />
    );
};

export default InputPassword;
